'use strict';
var React = require('react');
var Components = require('./Components.jsx');
var _ = require('underscore');

var Bottom = React.createClass({
  propTypes: {
    components: React.PropTypes.array.isRequired,
    pageSize: React.PropTypes.shape({
      width: React.PropTypes.number,
      height: React.PropTypes.number
    }).isRequired,
    bottom: React.PropTypes.number.isRequired,
    events: React.PropTypes.object.isRequired,
    onLinkClick: React.PropTypes.func.isRequired
  },
  render: function () {
    var limit = this.props.pageSize.height - this.props.bottom;
    var shouldRenderComponents = _.filter(this.props.components, function (item) {
      return item.y + item.h > limit;
    });
    return (
      <div key="bottom-page" className='page-bottom' style={{
        width: '100%',
        height: this.props.bottom,
        bottom: 0,
        position: 'absolute',
        overflow: 'hidden'
      }}>
        <div className='page-container' style={{marginTop: -this.props.pageSize.height + this.props.bottom}}>
          <Components components={shouldRenderComponents} events={this.props.events}/>
        </div>
      </div>
    );
  }
});

module.exports = Bottom;



// WEBPACK FOOTER //
// ./src/views/Page/Bottom.jsx